import { Grid, Skeleton } from "@mui/material";

export const TrandingGrid = () => {
  return (
    <Grid container spacing={2} alignItems={"center"}>
      {[1, 2, 3, 4, 5].map((item, i) => {
        return (
          <Grid item xs={12} sm={12} md={3} lg={2} key={i}>
            <Skeleton variant="rectangular" width="100%" height={150} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={20}
              sx={{ margin: "10px 0px 20px 0px" }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TrandingGrid;
